import type { BillingSettings, PriceItem, QuotableEvaluation, Quote, QuoteStatus, QuoteSummary } from '@dnx/contracts';
import { queryOptions } from '@tanstack/react-query';
import { api } from '../lib/api.js';

export const priceItemsQuery = queryOptions({ queryKey: ['billing', 'prices'], queryFn: () => api<PriceItem[]>('/price-items') });
export const billingSettingsQuery = queryOptions({ queryKey: ['billing', 'settings'], queryFn: () => api<BillingSettings>('/billing/settings') });
export const quotesQuery = (patientId?: string) => queryOptions({
  queryKey: ['quotes', 'list', patientId ?? ''], queryFn: () => api<QuoteSummary[]>(`/quotes${patientId ? `?paciente=${patientId}` : ''}`),
});
export const quoteQuery = (id: string) => queryOptions({ queryKey: ['quotes', id], queryFn: () => api<Quote>(`/quotes/${id}`) });
export const quotableQuery = queryOptions({ queryKey: ['quotes', 'quotable'], queryFn: () => api<QuotableEvaluation[]>('/quotes/quotable') });

export const UNIT_LABELS: Record<PriceItem['unit'], string> = { fixed: 'Valor fixo', per_graft: 'Por enxerto (UF)', per_session: 'Por sessão' };
export const UNIT_SHORT: Record<PriceItem['unit'], string> = { fixed: '', per_graft: '/UF', per_session: '/sessão' };
export const QUOTE_STATUS: Record<QuoteStatus, [string, 'neutral' | 'primary' | 'warning' | 'success' | 'danger']> = {
  draft: ['Rascunho', 'neutral'], sent: ['Enviado', 'primary'], accepted: ['Aceito', 'success'], expired: ['Vencido', 'warning'], cancelled: ['Cancelado', 'neutral'],
};

/** "1.234,56" → centavos. */
export function parseBRL(s: string): number | null {
  const clean = s.replace(/[^\d,.-]/g, '').replace(/\./g, '').replace(',', '.');
  if (!clean) return null;
  const n = Number(clean);
  return Number.isFinite(n) && n >= 0 ? Math.round(n * 100) : null;
}
export const centsToInput = (c: number) => (c / 100).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
export const pct = (bp: number) => `${(bp / 100).toLocaleString('pt-BR', { maximumFractionDigits: 2 })}%`;
export const brDate = (iso: string) => iso.slice(0, 10).split('-').reverse().join('/');
